module.exports = false;


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/~/core-js/modules/_library.js
 ** module id = 28
 ** module chunks = 12
 **/